/**
 * Initializes all scene objects to have the appropriate cursor when interactive (pointer for something that should be clicked on, hand if it's draggable)
 */
export default function initializeInteractiveCursor(scene: Phaser.Scene): void {
    scene.input.setDefaultCursor("default");
    scene.children.list.forEach((ob) => {
        if (ob.input != null && ob.input.enabled) {
            // Draggable objects
            if (ob.input.draggable) {
                if (ob.input.dragState === 2) { // Actively being dragged
                    ob.input.cursor = "-webkit-grabbing";
                }
                else {
                    ob.input.cursor = "-webkit-grab";
                }
            }
            // Normal objects
            else {
                ob.input.cursor = "pointer";
            }
        }
    });
}

/**
 * For an update loop
 */
export function updateInteractiveCursor(scene: Phaser.Scene): void {
    scene.children.list.forEach((ob) => {
        if (ob.input != null && ob.input.enabled) {
            // Draggable objects
            if (ob.input.draggable) {
                if (ob.input.dragState === 2 || ob.input.dragState === 1) { // Actively being dragged
                    ob.input.cursor = "-webkit-grabbing";
                }
                else {
                    ob.input.cursor = "-webkit-grab";
                }
            }
        }
    });
}



// WEBPACK FOOTER //
// ./src/games/shared/InteractiveCursorUtil.ts